import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import CheckboxItem from '../../atoms/CheckboxItem';
import Text from '../../atoms/Text';
import TextGroup from '../../molecules/TextGroup';
import ClassList from '../../organisms/ClassList';

import styles from './ConfirmAttendenceBlock.module.scss';
import usePresenter from './ConfirmAttendenceBlock.presenter';
import getProps from './ConfirmAttendenceBlock.props';
import { ConfirmAttendenceBlockCombinedProps } from './types';


const ConfirmAttendenceBlock: React.FC<ConfirmAttendenceBlockCombinedProps> = (props) => {
  const {
    className,
    classes,
    stepperText,
    textGroup,
    classList,
    checkboxItem,
    button,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.confirmAttendenceBlock;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.topContent, classes?.topContent)}>
        <Text
          className={cx(styles.stepperText, classes?.stepperText)}
          {...internalProps.stepperText}
          {...stepperText}/>
        <TextGroup
          className={cx(styles.textGroup, classes?.textGroup)}
          {...internalProps.textGroup}
          {...textGroup}/>
      </div>
      <div className={cx(styles.middleContent, classes?.middleContent)}>
        <div className={cx(styles.schedule, classes?.schedule)}>
          <ClassList
            className={cx(styles.classList, classes?.classList)}
            {...internalProps.classList}
            {...classList}/>
        </div>
        <CheckboxItem
          className={cx(styles.checkboxItem, classes?.checkboxItem)}
          {...internalProps.checkboxItem}
          {...checkboxItem}/>
      </div>
      <div className={cx(styles.bottomContent, classes?.bottomContent)}>
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}/>
      </div>
    </div>
  );
};

export default ConfirmAttendenceBlock;

